// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"97":"2548c456","115":"ff1ba60b","389":"138a6527","563":"2579a7f3","820":"5290cabb","935":"809608a7","965":"a06b71cc"}[chunkId] + ".css";
};